import React from 'react'
import Layout from '../../components/Layout'

const FiltersPage = () => {
    return (
        <React.Fragment>
            FiltersPage
        </React.Fragment>
    )
}

export default FiltersPage
